<template>
	<div class="page-width">
		<div class="full_width">
			<datatable title="Reports" :response="data" :fields="fields" :show_edit="false" :show_delete="false" 
						:filters="filters" :sorters="sorters" :operations="operations" :is_createable="false"
						@offers="showMonthOffers" :unique_buttons="unique_buttons" @orange="offers_unique_buttons.selectStatusGroup('Orange')" 
						@red="offers_unique_buttons.selectStatusGroup('Red')" @green="offers_unique_buttons.selectStatusGroup('Green')" 
						@past="offers_unique_buttons.toggleQueryParam('past')" @future="offers_unique_buttons.toggleQueryParam('future')">
			</datatable>
			<p v-if="total_income">TOTAL: <b>{{total_income}}</b></p>
		</div>
	</div>
</template>
<script>
	import { mapActions, mapMutations } from 'vuex'
	import OffersUniqueButtons from '@/classes/offers_unique_buttons.js'
	import TimeHelper from '@/classes/time_helper.js'
	import FiltersHelper from '@/classes/filters_helper.js'
	import OffersHelper from '@/classes/offers_helper.js'
	import Reports from '@/classes/reports.js'
	import Datatable from '@/components/Datatable'
	export default {
		name: 'offers',
		data(){
			let offers_helper = new OffersHelper()
			let offers_unique_buttons = new OffersUniqueButtons(this.$router)
			return {
				total_income: undefined,
				offers_unique_buttons,
				time_helper: new TimeHelper(),
				filters_helper: new FiltersHelper(),
				sorters: [
					{
						designator: 'id',
						value: '-id'
					},
					{
						designator: 'start_date',
						value: 'start_date'
					}
				],
				filters: [
			        {
			          type: 'multiple',
			          designator: 'statuses',
			          options: offers_helper.getFiltersOptions()
			        },
			        {
			        	type: 'single',
			        	designator: 'env',
			        	options: [
			        		{
			        			text: 'Suitup',
			        			value: 'Suitup',
			        		},
			        		{
			        			text: 'Rebase',
			        			value: 'Rebase',
			        		},
			        		{
			        			text: 'Office',
			        			value: 'Office',
			        		},
			        		{
			        			text: 'Piola',
			        			value: 'Piola',
			        		}
			        	]
			        },
			        {
			        	type: 'date',
			        	designator: 'from_date'
			        },
			        {
			        	type: 'date',
			        	designator: 'to_date'
			        },
			        {
			        	type: 'single',
			        	designator: 'sum_field_option',
			        	options: [
			        		{
			        			text: 'start_date',
			        			value: 'start_date',
			        		},
			        		{
			        			text: 'created_at',
			        			value: 'created_at',
			        		},
			        		{
			        			text: 'payment_date',
			        			value: 'payment_date',
			        		},
			        		{
			        			text: 'invoice_date',
			        			value: 'invoice_date',
			        		},
			        	]
			        }
				],
				fields: [
				    {
				      name: 'Year',
				      value: 'year'
				    },
				    {
				      name: 'Month',
				      value: 'month.display_text'
				    },
				    {
				      name: 'Income',
				      value: 'income.display_text'
				    },
				],
				data: [],
				unique_buttons: offers_unique_buttons.getUniqueButtons(),
				operations: [{ name: 'offers', icon: '/info.svg' }],
			}
		},
		created(){
			this.$network_utils.getOffersList({
				...this.filters_helper.getServerCallFilters(this.filters),
				company_id: this.$route.query.company_id,
				sort: this.$route.query.sort || 'start_date',
				past: this.$route.query.past,
				future: this.$route.query.future
			}).then(response => {
				let reports = new Reports(response, this.$route.query.sum_field_option)
				this.data = reports.getReports()
				this.total_income = reports.getTotalIncome()
			}).catch(() => {
				this.data = []
				this.total_income = undefined
				this.showToast('ארעה שגיאה בטעינת הדוחות')
			})
		},
		methods: {
			showMonthOffers(report){
				this.createModal({
					designator: 'report-month-offers-modal',
					component_name: 'ReportMonthOffers',
					data: report,
					modal_title: `Report Month Offers (שנת ${report.year} חודש ${report.month.display_text})`
				})
			},
			...mapMutations('modals', ['createModal']),
			...mapActions('toasts', ['showToast'])
		},
		components: {
			Datatable
		}
	}
</script>
<style scoped>
	.company_offers_only_text{
		width: 100%;
		text-align: center;
	}
</style>